import type { RatesSettings } from '@/settings/types';
import { apiGet, apiSend } from './client';

export function fetchRates(): Promise<RatesSettings> {
  return apiGet<RatesSettings>('/rates');
}

export function saveRates(rates: RatesSettings): Promise<RatesSettings> {
  return apiSend<RatesSettings>('/rates', 'PUT', rates) as Promise<RatesSettings>;
}
